import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileOpener } from '@capacitor-community/file-opener'

// Por bloques: String.fromCharCode(...bytes) revienta la pila con archivos grandes.
const BASE64_CHUNK_SIZE = 0x8000

async function blobToBase64 (blob) {
  const bytes = new Uint8Array(await blob.arrayBuffer())
  let binary = ''
  for (let offset = 0; offset < bytes.length; offset += BASE64_CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + BASE64_CHUNK_SIZE))
  }

  return btoa(binary)
}

// A diferencia de utils.download, no cambia el nombre y deja pasar el error de
// escritura: quien llama decide si el archivo llego al usuario. Abrirlo es
// aparte: sin app compatible el archivo sigue guardado y se devuelve opened: false.
export async function saveFileToDevice (filename, blob, mimeType) {
  const { uri } = await Filesystem.writeFile({
    path: filename,
    data: await blobToBase64(blob),
    directory: Directory.Data,
    recursive: true
  })

  try {
    await FileOpener.open({ filePath: uri, contentType: mimeType })

    return { uri, opened: true }
  } catch (error) {
    console.error(error)

    return { uri, opened: false }
  }
}
